import { useEffect, useState } from 'react';
import { TextField, TextFieldProps } from '@mui/material';

type TVTextFieldProps = TextFieldProps & {
  id?: string;
  valor?: (id: string, valor: string) => void;
}

export const VFieldMoney2ValorItem: React.FC<TVTextFieldProps> = ({ valor, id, ...rest }) => {
  const [editing, setEditing] = useState(false);

useEffect(() => {
  if (!editing && rest.value !== undefined) {
    setInputValue(formatValue(String(rest.value)));
  }
}, [rest.value, editing]);

  const formatValue = (inputValue: string | number): string => {
    let formattedValue: string;

    if (typeof inputValue === 'number') {
      inputValue = inputValue.toString();
    }

    if (!inputValue.includes('.')) {
      formattedValue = inputValue.replace(/\D/g, '');
      formattedValue += ',00'; // 🔥 alterado para 2 casas
      formattedValue = formattedValue.replace(/(\d)(?=(\d{3})+(,))/g, '$1.');
    } else {
      formattedValue = inputValue.replace(/\./g, ',');
      formattedValue = formattedValue.replace(/(\d+,\d{0,2})\d*/, '$1'); // 🔥 alterado
      formattedValue = formattedValue.replace(/(\d)(?=(\d{3})+(,))/g, '$1.');
    }

    return formattedValue;
  };

  const formatInputValue = (inputValue: string) => {
    inputValue = inputValue.replace(/\D/g, '');

    if (!inputValue) {
      return '';
    }

    inputValue = inputValue.replace(/(\d)(\d{2})$/, '$1,$2');
    inputValue = inputValue.replace(/(?=(\d{3})+(\D))\B/g, '.');

    return inputValue;
  };

  const formatSimple = (inputValue: string): string => {
    if (!inputValue) {
      return '';
    }

    inputValue = inputValue.replace(/\./g, '');
    inputValue = inputValue.replace(/,/g, '.');

    return inputValue;
  };

  const [inputValue, setInputValue] = useState('');
 

  return (
    <TextField
      {...rest}
      value={inputValue}
      onFocus={() => setEditing(true)}
      onBlur={() => {
        setEditing(false);

        if (inputValue) {
          setInputValue(
            formatValue(
              inputValue
                .replace(/\./g, '')
                .replace(',', '.')
            )
          );
        }
      }}
     onChange={(e) => {
  const formatted = formatInputValue(e.target.value);

  setInputValue(formatted);

  valor?.(
    id || '',
    formatSimple(formatted)
  );
}}
    />
  );
};